import {
  ClassSansProvider,
  FactorySansProvider,
  InjectionToken,
  Type,
} from '@angular/core';
import { TournamentsService } from './tournaments-service.interface';

export const DataAccessTournamentsService =
  new InjectionToken<TournamentsService>('TournamentsService');

export interface TournamentsServiceUseClass extends ClassSansProvider {
  useClass: Type<TournamentsService>;
}

export interface TournamentsServiceUseFactory extends FactorySansProvider {
  useFactory: (...args: unknown[]) => TournamentsService;
}

export type TournamentsServiceProvider =
  | TournamentsServiceUseFactory
  | TournamentsServiceUseClass;

export function provideDataAccessTournamentsService(
  config: TournamentsServiceProvider,
) {
  return {
    provide: DataAccessTournamentsService,
    ...config,
  };
}
